import { useCallback, useEffect, useMemo } from "react";
import styled from "styled-components";
import { AiOutlineSearch } from "react-icons/ai";
import debounce from "lodash.debounce";

import { EditorAction } from "features/shared/types/actions.editor";
import { useDispatch } from "services/redux/rootReducer";
import { useState } from "react";

const SearchBar = () => {
    const dispatch = useDispatch();
    const [searchKey, setSearchKey] = useState<string>("");

    const handleSearch = useCallback(
        (searchKey: string) => {
            dispatch({
                type: EditorAction.SET_SEARCH_FILTER_KEY,
                searchFilterKey: searchKey.trim(),
            });
        },
        [dispatch]
    );

    const debouncedSearchHandler = useMemo(
        () => debounce(handleSearch, 300),
        [handleSearch]
    );

    useEffect(() => {
        debouncedSearchHandler(searchKey);
    }, [searchKey, debouncedSearchHandler]);

    useEffect(() => {
        return () => {
            debouncedSearchHandler.cancel();
        };
    }, [debouncedSearchHandler]);

    return (
        <Container>
            <SearchLabel>
                <AiOutlineSearch />
            </SearchLabel>
            <SearchInput
                value={searchKey}
                onChange={(e) => setSearchKey(e.target.value)}
                placeholder="Search..."
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    align-items: center;

    & > * {
        min-height: 100%;
        color: ${(props) => props.theme.colors.neutral[300]};
        color: #a7b1c5;
        transition: all 0.2s linear;
    }

    &:focus,
    &:hover {
        & > * {
            color: ${(props) => props.theme.colors.neutral[500]};
        }
    }
`;

const SearchLabel = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5%;
    min-width: fit-content;
    margin-right: 2%;
`;

const SearchInput = styled.input`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    transition: all 0.1s linear;
`;

export default SearchBar;
